/** Height of the app bar when in mobile playground layout. */
export const MOBILE_APPBAR_HEIGHT = 48;
